import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChargerStatus {
  offline: number;
  faulty: number;
  cars_charging: number;
  full_charged_cars: number;
}

interface ChargerStatusState {
  charger_status: ChargerStatus | null;
}

const initialState: ChargerStatusState = {
  charger_status: null,
};

const chargerStatusSlice = createSlice({
  name: 'chargerStatus',
  initialState,
  reducers: {
    setChargerStatus(state, action: PayloadAction<ChargerStatus>) {
      state.charger_status = action.payload;
    },
  },
});

export const { setChargerStatus } = chargerStatusSlice.actions;

export default chargerStatusSlice.reducer;
